import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleCheck, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-toast-success',
  standalone: true,
  template: `
    <div *transloco="let t" class="d-flex align-items-center">
      <fa-icon [icon]="faCircleCheck" class="me-2"></fa-icon>
      <span>{{ t(message()) }}</span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent, TranslocoDirective],
})
export class ToastSuccessComponent {
  readonly faCircleCheck: IconDefinition = faCircleCheck;
  readonly message = input<string>('');
}
